
export const BASE_URL = process.env.NODE_ENV === 'production' ? '' : "http://localhost:3000"

export const TIMEOUT = 50000;


